var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasSku
    ? _c(
        "div",
        {
          staticClass:
            "woocommerce-variation--detail u-border-black-50--1 p-1 p-lg-2 mb-2",
          class: { "d-none": _vm.id === false },
        },
        [
          _vm.hasSku || _vm.hasMoldNumber
            ? _c(
                "div",
                {
                  staticClass:
                    "u-text-upper u-font-600 mb-1 d-flex justify-content-between justify-content-md-start",
                },
                [
                  _vm.hasSku
                    ? _c("div", { staticClass: "mr-2" }, [
                        _c("span", { staticClass: "u-font-400" }, [
                          _vm._v(_vm._s(_vm.itemCode) + ":"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.sku) + "\n        "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasMoldNumber
                    ? _c("div", [
                        _c("span", { staticClass: "u-font-400" }, [
                          _vm._v(_vm._s(_vm.labels.moldNumber) + ":"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.moldNumber) + "\n        "),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("table", { staticClass: "table--product-variation mb-2" }, [
            _c("thead", [
              _c("tr", [
                _vm.size
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.size))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.overflow
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.overflow))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.neckFinish
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.neckFinish))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.casePack
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.casePack))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.weight
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.weight))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dimensions
                  ? _c("th", [_vm._v(_vm._s(_vm.labels.dimensions))])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _vm.size ? _c("td", [_vm._v(_vm._s(_vm.size))]) : _vm._e(),
                _vm._v(" "),
                _vm.overflow
                  ? _c("td", [_vm._v(_vm._s(_vm.overflow))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.neckFinish
                  ? _c("td", [_vm._v(_vm._s(_vm.neckFinish))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.casePack
                  ? _c("td", [_vm._v(_vm._s(_vm.casePack))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.weight ? _c("td", [_vm._v(_vm._s(_vm.weight))]) : _vm._e(),
                _vm._v(" "),
                _vm.dimensions
                  ? _c("td", [_vm._v(_vm._s(_vm.dimensions))])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.isInStock ? _vm._t("default") : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.variation_id,
                expression: "variation_id",
                modifiers: { number: true },
              },
            ],
            staticClass: "variation_id",
            attrs: { type: "hidden", name: "variation_id" },
            domProps: { value: _vm.variation_id },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.variation_id = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }